<template>
  <div class="list-box">
    <edit-button :config="customSetting.config" :id="customSetting.id" @showTip="showTip"></edit-button>
    <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit" >
      <loading v-if="isloading"></loading>
      <div v-else class="container" ref="container">
        <top-bar :config="customSetting.config" :typeId="typeId" @updateList='updateList' @showTip="showTip"></top-bar>
       
       <!-- 标签start -->
        <div class="bqTag clearfix" v-if="customSetting.topic && customSetting.topic.length>0 ">
          <ul>
            <li @click="goRoute(item)" v-for="(item, index) in customSetting.topic" :key="index">{{customSetting.topic[index]}}</li> 
          </ul> 
        </div>
        <!-- 标签end -->

        <community-list v-if="list.length>0 && customSetting" :id="typeId" from="home"  :list="list"
          :title="customSetting.title.name"
           @showTip="showTip" ref="communityList"
        ></community-list>
        <div v-else class="no-data">
          <!-- <img class="img" src="https://h5.chuanbaoguancha.cn/cbgc-miniprogram/static/images/baoliao/blank.png?v=1.0" alt="没有数据"></img>
          <p class="text">暂时还没有数据</p> -->
          <router-link :to="'/publish/' + typeId">
            <img class="blank" src="~assets/imgs/blank.png"></img>
            <p>竟然还没有内容呐！占领它！</p>
          </router-link>
        </div>
        
      </div>
    </mescroll-vue>
    <modal v-show="tip" ref="tip" :download="download" :content="tip"></modal>
    <modal-normal v-show="showVersionTip" ref="tipversion" content="请升级到最新版本的APP"></modal-normal>
  </div>
    
</template>
<script>
  import Modal from 'components/tips/Modal.vue';
  import ModalNormal from 'components/tips/ModalNormal.vue';
  import Loading from 'components/tips/Loading.vue';
  import TopBar from 'components/list/TopBar.vue';
  import CommunityList from 'components/list/CommunityList.vue';
  import editButton from 'components/edit-btn/editButton.vue';
  import MescrollVue from 'mescroll.js/mescroll.vue';
  

  import { getCustomSetting, getList, getAppVersion ,isAppOrWeixin} from 'assets/js/community.js';
  // import func from '../../../vue-temp/vue-editor-bridge';
 
  export default {
    name: 'Home',
    data(){
      return {
        showVersionTip: false,
        customSetting: '',
        typeId: '99',
        list: [],
        htList:'',
        pagination: '',

        tip: '',
        download: true,
        isloading: true,

        mescroll: null,
        mescrollDown:{
          auto: false, 
          callback: this.downCallback
        },
        mescrollUp:{
          auto: false, // 是否在初始化时以上拉加载的方式自动加载第一页数据; 默认false
          callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page) { upCallback(page); }
          page: {
            num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
            size: 10 // 每页数据的数量
          },
          noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
          toTop: { // 配置回到顶部按钮
            src: require('assets/imgs/mescroll/mescroll-totop.png')
          }
        }

      }
    },
    computed:{
      user(){
        return this.$store.state.user;
      },
      tokens(){
        return this.$store.state.tokens;
      }
      
    },
    beforeCreate(){
     
      this.$route.params && this.$route.params.id && (this.typeId = this.$route.params.id);
      console.log('1,typeId:', this.typeId, typeof(this.typeId));
      typeof(this.typeId) == 'string' && (this.typeId = parseInt(this.typeId));
      console.log('2,typeId:', this.typeId, typeof(this.typeId));
      getCustomSetting(this.typeId).then(res=>{
        console.log('res:', res);
        this.customSetting = res;
        document.title = res.title.name;

      });
    },
    created(){
    
      this.typeId = this.$route.params.id || location.pathname.split('/')[3];
      // console.log('this.$route.params:', this.$route.params,location.pathname );
      // this.$store.dispatch('cbgcAuth', {
      //   cacheName: 'cbgcAuth',
      //   refresh: 1
      // }).then(res=>{
      //   this.loadData();
      // });
      console.log('typeId:', this.typeId);
      isAppOrWeixin().then(res=>{
        console.log('isAppOrWeixin:', res);
        if(!res){
          console.log('直接loaddata！！');
          this.loadData();
        }else{
          if(this.typeId == 99){
            getAppVersion().then(res=>{
              console.log('getAppVersion: ',res);
              let version = res.split('.')[0];
              if(version.length > 1){
                this.loadData();
              }else{
                console.log('是否低于7.0版本', Math.floor(version) < 7, res.system );
                Math.floor(version) < 7 ? (this.showVersionTip = true, this.isloading = false) : this.loadData();
              }
            });
          }else{
            console.log('this.$route.params:', this.$route.params,location.pathname );
            this.$store.dispatch('cbgcAuth', {
              cacheName: 'cbgcAuth',
              refresh: 1
            }).then(res=>{
              this.loadData();
            });
          }
        }
        
      }).catch(err=>{
        console.log('isAppOrWeixin err:', err);
      })
    },
    components: {
      TopBar,
      CommunityList,
      editButton,
      MescrollVue,
      Modal,
      ModalNormal,
      Loading
    },
    beforeRouteEnter (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteEnter不用写
      next(vm => {
        // 滚动到原来的列表位置,恢复顶部按钮和isBounce的配置
        vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter()
      })
    },
    beforeRouteLeave (to, from, next) { // 如果没有配置顶部按钮或isBounce,则beforeRouteLeave不用写
      // 记录列表滚动的位置,隐藏顶部按钮和isBounce的配置
      this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave()
      next()
    },
    methods:{
      goRoute(item){
          this.$router.push( {path:`/topicList/${this.typeId}/topic/${encodeURIComponent(item)}`})
      },
      cbgcAuth(){
        this.$store.dispatch('cbgcAuth', {
          cacheName: 'cbgcAuth',
          refresh: 1
        }).then(res=>{
        });
      },
      async loadData(params){
        // console.log('loadData params:', params, this.typeId);
        isAppOrWeixin().then(async res=>{
          if(res){
            let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
            if(tokens.status){
              this.$emit('showTip', tokens.message);
              return;
            }
            tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
          }
          
        });
        // 不是微信或者客户端就直接浏览列表页面
       

        getList(this.typeId, this.tokens, params && params.page, 'two_comment').then(res=>{
          this.isloading = false;
          let temp = [];
          if(!this.list.length || this.list[0].id !== res.data[0].id){
            // this.list = (params && params.loadmore) ? [...this.list, ...res.data] : res.data;
            params && params.loadmore && this.list.length && (temp = this.list);
            this.list =  temp.length>0?[...temp, ...res.data]:res.data;
            this.pagination = Object.assign({}, this.pagination, res.meta.pagination);
          }
          if(params.refresh){
            // console.log('loadData refresh!!')
            this.list = [...res.data];
          }
          params && params.successCallback && params.successCallback();
          
        }).catch(err=>{
          params && params.errorCallback && params.errorCallback();
        });
      },
      updateList(){
        this.loadData({refresh: 1});
      },

     

      pullDownRefresh(fn){
        // console.log('pullDownRefresh!!!!')
        this.loadData({
          page: 1,
          successCallback: fn.success,
          errorCallback: fn.error,
          refresh: 1
        }); 
        
      },
      pullUploadMore(fn){
        // console.log('pullUploadMore!!!!!', this.pagination);
        if(this.pagination.current_page < this.pagination.total_pages){
          this.loadData({
            page: this.pagination.current_page + 1,
            successCallback: fn.success,
            errorCallback: fn.error,
            loadmore: 1
          });
        }else{
          fn.error();
        }
        
      },
      mescrollInit (mescroll) {
        this.mescroll = mescroll;
      },
      /* 下拉刷新的回调 */
      downCallback () {
        // console.log('this.mescroll.version=' + this.mescroll.version);
        // 联网加载数据
        let mescroll = this.mescroll;
        this.pullDownRefresh({
          success: function(){
            this.$nextTick(() => {
              mescroll.endSuccess();
            });
          },
          error: function(){
            mescroll.endErr();
          }
        });
      },

      // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
      upCallback (page) {
        // 联网加载数据
        let mescroll = this.mescroll;
        this.pullUploadMore({
          success: function(){
            this.$nextTick(() => {
              mescroll.endSuccess()
            });
          },
          error: function(){
            mescroll.endErr();
          }
        });
       
      },
      showTip(tip){
        this.tip = tip;
        this.$refs.tip.taggle(true);
      }
    },
    watch:{
      showVersionTip:{
        handler(nV, oV){
         this.data = nV;
          console.log('watch data: ',this.data);
        },
        deep:true
      },
    }
  }
</script>
<style lang="scss" scoped>
 /* .mescroll {
    position: absolute;
    top: 0;
    bottom: 0;
    height: auto;
  } */
  #app{
    min-height: 100vh;
    height: auto;
    position: relative;
  }
  .mescroll{
    position: fixed;
    left:0;
    top:0;
  }
  .mescroll-totop{
    right: .5em;
    bottom: .3em;
    font-size: 2.2em;
    width: 1.8em;
    height: 1.8em;
  }
  .nodata{
    padding: 1.5em 0;
    .img, .text{
      display: block;
      margin: 0 auto;
      text-align: center;
    }
    .img{
      width: 60%;
      margin-bottom: 1em;
    }
  }
ul li{list-style:none;}
.clearfix:before,
.clearfix:after {
    content:"";
    display:table;
}
.clearfix:after {
    clear:both;
    overflow:hidden;
}
.clearfix {
    *zoom: 1;
}
.bqTag ul{margin-left:-7%;}
.bqTag li{float: left; _display:inline; color:#fff;font-size: 1em; height: 1.5em; line-height: 1.5em; background: blue; border-radius:8px; padding:0 3px; margin:0 6px 5px;}

</style>